import React, { useContext } from 'react';
import { AppBar, Toolbar, Typography, Button, Box, alpha, getContrastRatio } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { Link, useParams } from 'react-router-dom';
import { MenuPublico } from './MenuPublico';
import { CalculosAFP } from './Aportaciones/Federales/CalculosAFP';
import { MontosAFP } from './Aportaciones/Federales/MontosAFP';
import { AcuerdosAFP } from './Aportaciones/Federales/AcuerdosAFP';

const orangeBase = '#ff8400';
const grayBase = '#f2f2f2';

const theme = createTheme({
  palette: {
    primary: {
      main: orangeBase,
      light: alpha(orangeBase, 0.5),
      dark: alpha(orangeBase, 0.7),
      contrastText: '#ffffff',
    },
    secondary: {
      main: grayBase,
      light: alpha(grayBase, 0.5),
      dark: alpha(grayBase, 0.7),
      contrastText: '#ff8400',
    },
  },
});


const HomePageAF: React.FC = () => {
  const { tipo } = useParams()
  return (
    <div className="main-content-wrapper">
      <ThemeProvider theme={theme}>
        <MenuPublico selectedLink={3} />
        <Button color="primary" size="large" variant="contained" className="category-btn">
          <Typography variant="h6">APORTACIONES FEDERALES</Typography>
        </Button>
        <div className="nav-categories">
          <Button color={tipo === 'montos' ? "primary" : "secondary"} size="large" variant="contained" component={Link} to="/aportaciones-federales/montos" className="category-btn">
            <center>Montos</center>
          </Button>
          <Button color={tipo === 'acuerdos' ? "primary" : "secondary"} size="large" variant="contained" component={Link} to="/aportaciones-federales/acuerdos" className="category-btn">
            <center>Acuerdos</center>
          </Button>
          <Button color={tipo === 'calculos' ? "primary" : "secondary"} size="large" variant="contained" component={Link} to="/aportaciones-federales/calculos" className="category-btn">
            <center>Cálculos</center>
          </Button>
        </div>
        {
          tipo === 'montos' &&
          <MontosAFP />
        }
        {
          tipo === 'acuerdos' &&
          <AcuerdosAFP />
        }
        {
          tipo === 'calculos' &&
          <CalculosAFP />
        }

      </ThemeProvider>

    </div>
  );
};

export default HomePageAF;
